import GroupIcon from '@mui/icons-material/Group';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import HomeIcon from '@mui/icons-material/Home';
import AboutIcon from '@mui/icons-material/Info';
import FlagIcon from '@mui/icons-material/Flag';
import EmailIcon from '@mui/icons-material/Email';
import PeopleIcon from '@mui/icons-material/People'
import FeedbackIcon from '@mui/icons-material/Feedback';
import LiveTvIcon from '@mui/icons-material/LiveTv';
import CardMembershipIcon from '@mui/icons-material/CardMembership';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import HistoryIcon from '@mui/icons-material/History';
import PrintIcon from '@mui/icons-material/Print';

export const NavLinks = [
    { name: 'User', path: '/admin/user', current: true, Icon: GroupIcon },
    { name: 'Request', path: '/admin/contact-request', current: true, Icon: EmailIcon },
    { name: 'Home', path: '/admin/cms/home-page', current: true, Icon: HomeIcon },
    { name: 'About', path: '/admin/cms/about-page', current: true, Icon: AboutIcon },
    { name: 'Investor Week', path: '/admin/cms/investor-week-page', current: true, Icon: FlagIcon },
    { name: 'Investor Award', path: '/admin/cms/investor-award-page', current: true, Icon: EmojiEventsIcon },
    { name: 'Season 4', path: '/admin/cms/season-4', current: true, Icon: LiveTvIcon },
    {name:  'Participations',path:'/admin/participations', current: true, Icon: PeopleIcon},
    {name:  'Feedbacks',path:'/admin/feedbacks', current: true, Icon: FeedbackIcon},
    // Sidebar.js renders `name` verbatim, so these stay plain English strings
    // like every entry above. There is no role/permission gate in this app to
    // hang these off - AuthGuard only checks that a token exists, and `current`
    // is a styling flag for the mobile panel, not an ACL.
    //
    // `section` opens a titled group: both sidebars print it above the link that
    // carries it and run the following links underneath. Keeping the array flat
    // rather than nesting the groups means nothing that maps over these links
    // has to learn a second shape.
    {
        section: 'Certificates',
        name: 'Certificate Names',
        path: '/admin/certificate-names',
        current: true,
        Icon: CardMembershipIcon,
    },
    { name: 'Verify Name', path: '/admin/verify-name', current: true, Icon: FactCheckIcon },
    { name: 'Verification History', path: '/admin/verification-history', current: true, Icon: HistoryIcon },
    // Prints a certificate for a name that is not on the approved list at all -
    // the way a member added after the list was fixed still gets theirs.
    { name: 'Print Certificate', path: '/admin/print-certificate', current: true, Icon: PrintIcon }
];
